import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AlertController, Loading, LoadingController } from "ionic-angular";
import { Observable } from "rxjs/Observable";

@Injectable()
export class SemovelProvider {
  produtoSelecionado: {
    nome: string;
    embalagem: string;
    preco: number;
    imagem: string;
    id: number;
  };

  // url = "http://localhost:3000/app/";
  url = "https://nutrimar.murilosolucoes.com.br/app/";
  imagens = "assets/img/";

  token_acesso: string;

  loading: Loading;

  constructor(
    public http: HttpClient,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
  ) {}

  public postData(
    request,
    dados: any = {},
    exibirLoad = true,
  ): Observable<any> {
    if (request.method == null) {
      return Observable.create((obs) => {
        obs.error("Informe o metódo de requisição.");
      });
    }

    if (exibirLoad) {
      this.showLoading();
    }

    return Observable.create((observer) => {
      let headers = new HttpHeaders().set(
        "Content-Type",
        "application/json; charset=utf-8",
      );

      if (!dados) {
        dados = {};
      }

      if (this.token_acesso) {
        headers = headers.set("authorization", "Bearer " + this.token_acesso);
      }

      const body = JSON.stringify(dados);
      const options = { headers: headers };
      this.http.post(this.url + request.method, body, options).subscribe(
        (dados) => {
          if (exibirLoad) {
            this.loading.dismiss();
          }

          const retorno: any = dados;
          if ("sucesso" in retorno && !retorno.sucesso) {
            this.showMessage(retorno.mensagem);
          } else {
            observer.next(retorno);
          }
          observer.complete();
        },
        (error) => {
          if (exibirLoad) {
            this.loading.dismiss();
          }

          let status = error.status;
          console.error(error);

          if (status == 403) {
            observer.error("Acesso negado ao serviço.");
          } else if (status == 400) {
            observer.error("Erro realizar sua requisição ao servidor.");
          } else {
            observer.error("Erro de Conexão Código:" + status + ".");
          }
        },
      );
    });
  }

  public showLoading() {
    this.loading = this.loadingCtrl.create({
      content: "Aguarde...",
      dismissOnPageChange: false,
    });
    this.loading.present();
  }

  public showError(text) {
    let alert = this.alertCtrl.create({
      title: "Falha",
      subTitle: text,
      buttons: ["OK"],
    });
    alert.present();
  }

  public showMessage(text) {
    let alert = this.alertCtrl.create({
      title: "Info",
      subTitle: text,
      buttons: ["OK"],
    });
    alert.present();
  }

  public getImagemUrl(imagem): string {
    if (imagem) {
      return imagem.url;
    } else {
      return "assets/imgs/logo_loja.png";
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/semovel/semovel.ts